/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ReconcileOnboardingMutationResponse, ReconcileOnboardingPathParams, ReconcileOnboarding400, ReconcileOnboarding401, ReconcileOnboarding403, ReconcileOnboarding404, ReconcileOnboarding409, ReconcileOnboarding500 } from "../../types/onboardingController/ReconcileOnboarding.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getReconcileOnboardingUrl(organizationId: ReconcileOnboardingPathParams["organizationId"]) {
  const res = { method: 'POST', url: `/api/organizations/${organizationId}/onboarding/reconcile` as const }
  return res
}

/**
 * @summary Re-derive and materialize onboarding activation
 * {@link /api/organizations/:organizationId/onboarding/reconcile}
 */
export async function reconcileOnboarding(organizationId: ReconcileOnboardingPathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ReconcileOnboardingMutationResponse, ResponseErrorConfig<ReconcileOnboarding400 | ReconcileOnboarding401 | ReconcileOnboarding403 | ReconcileOnboarding404 | ReconcileOnboarding409 | ReconcileOnboarding500>, unknown>({ method : "POST", url : getReconcileOnboardingUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}